import axios from 'axios';
import { ACCOUNT_API_ORIGIN } from '@/config/domains';
import { API_TIMEOUT } from '@/utils/constants';

// Account API 实例，用于用户授权和用户信息相关的请求
const accountApi = axios.create({
  baseURL: ACCOUNT_API_ORIGIN,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // 支持 cookie
});

// 请求拦截器
accountApi.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
accountApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 统一错误处理
    if (error.response) {
      const { status, data } = error.response;
      console.error(`Account API Error: ${status}`, data);

      switch (status) {
        case 401:
          // 未授权，设置认证状态为 false，ProtectedRoute 会自动弹出登录弹窗
          import('@/stores/authStore').then(({ authStore }) => {
            authStore.setUser(null);
          });
          break;
        case 403:
          // 禁止访问
          break;
        case 404:
          // 资源不存在
          break;
        case 500:
          // 服务器错误
          break;
        default:
          break;
      }
    } else if (error.request) {
      console.error('Account API Network Error', error.request);
    } else {
      console.error('Account API Error', error.message);
    }

    return Promise.reject(error);
  },
);

export default accountApi;
